export const locale = "en-US";

export const tokens = {
	EMAIL_ADDRESS: "Email Address",
	PASSWORD: "Password",
	REMEMBER_ME: "Remember me",
	FORGOT_PASSWORD: "Forgot Password?",
	LOG_IN: "Log In",
	NO_ACCOUNT: "Don't have a Petdata account? ",
	SIGN_UP: "Sign Up",
	OR: " or ",
	VIEW_DEMO: "View Demo",
	INVALID_CREDENTIALS: "Invalid email address or password.",
	PLEASE_REENTER: "Please re-enter",

	LABELS: "Labels",
	CARE_SHEETS: "Care Sheets",
	ADVERTISING_SPACE: "Advertising Space",
	STORE_INFO_LOGO: "Store Info / Logo",
	ARTICLE_MANAGEMENT: "Article Management",
	USERS: "Users",
	LOG_OUT: "Log Out",
	CHANGE_STORE: "Change Store",
	
	PET_SEARCH_PLACEHOLDER: "Search for a pet, PLU, or specification. For example: Parrot Africa",
	
	CREATE_USER: "Create User",
	NAME: "Name",
	STATUS: "Status",
	ACTIVE: "Active",
	INACTIVE: "Inactive",

	USER_INFO: "User Info",
	FIRST_NAME: "First Name",
	LAST_NAME: "Last Name",
	CONFIRM_PASSWORD: "Confirm Password",
	CANCEL: "Cancel",

	PERMISSIONS: "Permissions",
	LOCATION: "Location",
	PRINT_CARE_SHEETS: "Print Care Sheets",
	PRINT_LABELS: "Print Labels",
	EDIT_AD_SPACE: "Edit Ad Space",
	EDIT_STORE_INFO_LOGO: "Edit Store Info / Logo",
	
	EDIT_USER: "Edit User",
	CHANGE_PASSWORD: "Change Password",
	SAVE: "Save",

	ADVERTISING_DETAILS: "Your ad must be 57 x 128 mm or 673 x 1512 px @ 300 dpi. JPG or PNG formats accepted. Your ad will display on the care sheet for each specific pet type.",
	PET_TYPE: "Pet Type",
	AD_UPLOADED: "Ad Uploaded",
	UPLOAD: "Upload",
	CLEAR: "Clear",

	STORE_INFO_DETAILS: "Choose whether to use your store information or logo on pet care sheets.",
	STORE_INFO: "Store Info",
	LINE1: "Line 1",
	LINE2: "Line 2",
	LINE3: "Line 3",
	LINE4: "Line 4",
	USE_LOGO_INSTEAD: "I want to use my logo instead",
	UPLOAD_LOGO: "Upload Logo",
	STORE_LOGO_DETAILS: "Your logo must be 57 x 45 mm or 673 x 531 px @ 300 dpi.",
	STORE_LOGO_FORMATS: "JPG or PNG formats accepted.",

	PREVIEW_CARE_SHEET: "Preview Care Sheet",

	SEARCH_PETS: "Search Pets",
	SEARCH_FOR_A_PET: "Search for a pet",
	NO_RESULTS_TRY_AGAIN: "No Results. Please try again.",
	DOWNLOAD: "Download",

	SAVED_SUCCESSFULLY: "Saved successfully",

	SELECT: "Select",

	CUSTOMIZE_COLORS_LOGO: "Customize Colors",
	PAGE_SETUP: "Page Setup",
	GENERATE: "Generate",
	PLU: "PLU",
	ENABLE_PLU: "Enable PLU",
	PLU_CONFIRMATION: "Enabling the PLU field will clear the current label sheet. Do you want to continue?",
	YES: "Yes",
	NO: "No",
	CREATE_LABEL: "Create Label",
	CREATE_CUSTOM_LABEL: "Create Custom Label",
	OR_CREATE_CUSTOM_LABEL: "or create a custom label",
	RESULTS: "Results",
	BACK_SEARCH_RESULTS: "Back to search results",
	BACK_TO_LABELS_SEARCH_RESULTS: "Back To Labels",
	ENTER_PRICE_SEARCH_RESULTS: "Price",
	ENTER_PRICE: "Enter Price",
	ENTER_PLU: "Enter PLU",
	EDIT_LABEL: "Edit Label",
	SAVE_LABEL: "Save Label",
	ENTER_BARCODE: "Enter EAN Barcode",
	ENTER_NAME: "Enter Name",
	ENTER_LATIN_NAME: "Enter Latin Name",
	CUSTOM_LABEL: "Custom Label",
	LABEL_SIZE: "Label Size",
	
	DUPLICATE_ROW: "Duplicate Row",
	CLEAR_ROW: "Clear Row",
	ARTICLE_INSTRUCTIONS: "You can enter the price, PLU and EAN code and an Integrationsname, which are then displayed on the label (Advanced Settings). The Integrationsname is useful if you want a different name than the default name or if there are several entries for the same animal. You can enter the values in the table directly or download as Excel file (File Download), edit and upload with the changes (File Upload).",
	UPLOAD_FILE: "Upload File",
	EXPORT_TO_EXCEL: "Export To Excel",

	CUSTOMIZE_LABEL: "Customize Label",
	MAIN: "Main",
	BORDER: "Border",
	IMAGE_BORDER: "Image Border",
	BACKGROUND: "Background",
	LABEL: "Labeldetails",
	TEXT: "Text",
	PRICE: "Price",
	TITLE: "Header",
	DETAIL: "Labeldetails Title",
	BARCODE: "Barcode",
	RESTORE_DEFAULT_COLORS: "Restore Default Colors",
	LOGO: "Logo",
	LOGO_FORMAT: "202 x 118 Pixel @ 300 dpi",
	RIGHTCOLUMN: "Right Column",
	
	PRINTER_ADJUSTMENT: "Printer Adjustment",
	ADJUSTMENT_INSTRUCTIONS: "In order to place labels with millimeter precision, the printout can be adjusted vertically and horizontally. <P> <br /> Horizontal: <br /> If the label is to be used e.g. 5 mm to the right, enter 5 in the Horizontal (mm) box. Entering -5 moves the label 5 mm to the left. </ P> <p> <br /> Vertical: <br /> If the label is e.g. by 3 mm, enter 3 in the Vertical (mm) field. Enter -3 to move the label down by 3mm. </ P> <p> <br /> Tip: <br /> If the label does not match the specified size, deactivate the zoom setting in the printer setting, which is the default setting for some printers. </ p> ",
	A_VERTICAL: "A (vertical)",
	B_HORIZONTAL: "B (horizontal)",


	
	
	CUSTOM_LABEL_PET_LAT_NAME: "Paracheirodon innesi",
	CUSTOM_LABEL_PET_NAME: "Neon Tetra",
	CUSTOM_LABEL_PET_PRICE: "1.99 $",

	CUSTOM_LABEL_KEY_1: "Size",
	CUSTOM_LABEL_VALUE_1: "4 cm",
	CUSTOM_LABEL_KEY_2: "Origin",
	CUSTOM_LABEL_VALUE_2: "South America",
	CUSTOM_LABEL_KEY_3: "Temp.",
	CUSTOM_LABEL_VALUE_3: "21-26 °C",
	CUSTOM_LABEL_KEY_4: "Diet",
	CUSTOM_LABEL_VALUE_4: "Carnivore",
	CUSTOM_LABEL_KEY_5: "Keeping",
	CUSTOM_LABEL_VALUE_5: "Group",
	CUSTOM_LABEL_KEY_6: "Aquarium",
	CUSTOM_LABEL_VALUE_6: "60 cm / 54 l",

	CUSTOM_LABEL_KEY_7: "Family",
	CUSTOM_LABEL_VALUE_7: "Characidae",
	CUSTOM_LABEL_KEY_8: "Origin",
	CUSTOM_LABEL_VALUE_8: "South America",
	CUSTOM_LABEL_KEY_9: "Habitat",
	CUSTOM_LABEL_VALUE_9: "Tributaries",
	CUSTOM_LABEL_KEY_10: "Temperature",
	CUSTOM_LABEL_VALUE_10: "21-26 °C",
	CUSTOM_LABEL_KEY_11: "pH",
	CUSTOM_LABEL_VALUE_11: "5,5-7,5",
	CUSTOM_LABEL_KEY_12: "Hardness",
	CUSTOM_LABEL_VALUE_12: "5-15 °dH",
	CUSTOM_LABEL_KEY_13: "Life Span",
	CUSTOM_LABEL_VALUE_13: "5 years",
	CUSTOM_LABEL_KEY_14: "Behavior",
	CUSTOM_LABEL_VALUE_14: "Peaceful",
	CUSTOM_LABEL_KEY_15: "Temperament",
	CUSTOM_LABEL_VALUE_15: "",
	CUSTOM_LABEL_KEY_16: "Reporduction",
	CUSTOM_LABEL_VALUE_16: "Egg scatterers",
	CUSTOM_LABEL_KEY_17: "Care Level",
	CUSTOM_LABEL_VALUE_17: "Easy",
	CUSTOM_LABEL_KEY_18: "Breeding",
	CUSTOM_LABEL_VALUE_18: "Moderately difficult",
	CUSTOM_LABEL_KEY_19: "Protection Agrmt.",
	CUSTOM_LABEL_VALUE_19: "No",

	PAGE_NOT_FOUND: "404 Page Not Found",
	GO_BACK_TO_HOMEPAGE: "Go back to homepage",

	PLEASE_ENTER_FIRST_NAME: "Please enter a first name.",
	PLEASE_ENTER_LAST_NAME: "Please enter a last name.",
	PLEASE_ENTER_VALID_EMAIL: "Please enter a valid email address",
	PASSWORD_CHARACTERS: "Your password must be between 8-100 characters.",
	PASSWORDS_DO_NOT_MATCH: "Passwords do not match",


	EDIT: "Edit",
	NEW_PASSWORD: "New Password",

	ACCESS_WELCOME: "Welcome to Petdata",

	PRINT_CALIBRATION_PAGE: "Print Calibration Page",

	PREVIEW: "Preview",
	CURRENT_PASSWORD: "Current Password",
	SEND_PASSWORD: "Reset Password",

	RESET_PASSWORD_HEADER:"Please enter your email address.",
	RESET_PASSWORD_BACK:"Back to Login",
	RESET_PASSWORD_CONFIRMATION:"Your password has been sent to the provided email address.",

	APPLICATION_ERROR: "Application Error",
	ERROR_MESSAGE: "An application error has occurred. Please contact an administrator if you continue to experience issues.",

	LABEL_ADDED: "Label Added",
	LABEL_ADDED_MESSAGE: "Successfully added the chosen pet to the label sheet.",
	CONTINUE: "Continue",
	ADD: "Add",

	MANAGEMENT: "Management",

	DEMO_DE_LOGIN:"Deutsche Demo",
	DEMO_EN_LOGIN:"English Demo",
	DEMO_TEXT:"Our demo lets you explore most of our application. Only user management and detailed label editing features are disabled.",
	DEMO_TITLE:"Start Demo",


	ADVANCED_SETTINGS_LINK:"Advanced Settings",
	ADVANCED_SETTINGS_LABEL_PAGE_TITLE:"Advanced Settings",
	
	ADVANCED_SETTINGS_LABEL_PLU_TITLE:"PLU Code",
	ADVANCED_SETTINGS_LABEL_PLU_DESCRIPTION:"Petdata Labels support a PLU Code field. This feature can be disabled.",
	ADVANCED_SETTINGS_LABEL_PLU_FIELD:"Use PLU Code",
	ADVANCED_SETTINGS_LABEL_HEADER_TITLE:"Label Title",
	ADVANCED_SETTINGS_LABEL_HEADER_FIELD:"Order",
	ADVANCED_SETTINGS_LABEL_HEADER_DESCRIPTION:"Each label has two lines for the name of the animal. The assignment of these two lines can be configured.",
	ADVANCED_SETTINGS_LABEL_METRIC_TITLE:"System of measurement",
	ADVANCED_SETTINGS_LABEL_METRIC_DESCRIPTION:"Animal information is available in two different measurement systems.",
	ADVANCED_SETTINGS_LABEL_METRIC_FIELD:"System of measurement",
	ADVANCED_SETTINGS_LABEL_PAGE_FORMAT_TITLE:"Page format",
	ADVANCED_SETTINGS_LABEL_PAGE_FORMAT_DESCRIPTION:"Petdata support A4 and Letter formats for the generated PDFs.",
	ADVANCED_SETTINGS_LABEL_PAGE_FORMAT_FIELD:"Format",
	ADVANCED_SETTINGS_LABEL_PRINTER_CALIBRATION_TITLE:"Printer Adjustment",

	ADVANCED_SETTINGS_LABEL_HEADER_N_LAT:"Line 1: Common Name; Line2: Scientific Name",
	ADVANCED_SETTINGS_LABEL_HEADER_LAT_N:"Line 1: Scientific Name; Line 2: Common Name",
	ADVANCED_SETTINGS_LABEL_HEADER_IN_N_LAT:"Line 1: Integrationsname from Article Management, if available, otherwise Common Name; Line 2: Scientific Name",

	ADVANCED_SETTINGS_LABEL_METRIC_US:"United States customary units (inch, gallon, degrees Farenheit, pound, …)",
	ADVANCED_SETTINGS_LABEL_METRIC_EU:"Metric system (meter, liter, degrees Celsius, kilogramm, …)",

};


/** WEBPACK FOOTER **
 ** ./src/translations/en-US.js
 **/